import { Field } from 'formik';
import { SttFormControl, SttFormGroup, SttFormControlLabel, SttCheckbox } from '@stt-componentes/core';
import { EXAME_PRIORIZADO } from '../fieldNames';

const ExamePriorizado = ({ strings }) => {
    
    return (
        <Field name={EXAME_PRIORIZADO}>
            {({
                field: { checked, name, ...other},
                form
            }) => (
                <SttFormControl variant="outlined">
                    <SttFormGroup row>
                        <SttFormControlLabel
                            control={
                                <SttCheckbox
                                    {...other}
                                    namne={name}
                                    color="primary"
                                    checked={checked || form.values[EXAME_PRIORIZADO]}
                                    onChange={e => form.setFieldValue(name, e.target.checked)}
                                />
                            }
                            label={strings.examePriorizado}
                        />
                    </SttFormGroup>
                </SttFormControl>
            )}
        </Field>
    );
};

export default ExamePriorizado;